const ru = {
  10000001: 'Празднование 2-й годовщины SuperEx',
  10000002: 'Регистрируйтесь и получайте отличные награды!',
  10000003: 'В зависимости от количества участников, чем больше участников, тем больший призовой фонд будет разблокирован, вплоть до 10 000USDT. ',
  10000004: '2-я годовщина SuperEx',
  10000005: 'Выиграйте 20 000 USDT в конкурсе по празднованию контракта',
  10000006: `Конкурс рейтинга торговых объемов: Разблокируйте главный приз - бонусный пул в размере <span style="color: #ffc72b;">10,000</span> USDT. `,
  10000007: 'Чемпионат по фьючерсам',
  10000008: 'Выиграйте 20 000 USDT в конкурсе по празднованию контракта',

  10000009: 'Выбрать',
  10000010: 'Общее предложение',
  10000011: 'Исследовать',
  10000012: 'Вернуться',
  10000013: 'Дальше',
  10000014: 'Предыдущий',
  10000015: 'Заполните информацию',
  10000016: 'Пожалуйста, введите название токена',
  10000017: 'Введите полное имя токена.',
  10000018: 'Понял',
  10000019: 'Укажите имя экземпляра торговой пары.',
  10000020: 'Пожалуйста, укажите оборотное предложение токена.',
  10000021: 'Готово',
  10000022: 'После этого вы можете просмотреть статистические данные по данной торговой паре на странице Free Market на сайте.',
  10000023: '{currency} листинг на бирже!',
  10000024: 'Год',
  10000025: 'Месяц',
  10000026: 'День',

  8000067: 'Статистика',
  8000068: 'Название токена',
  8000069: 'Основная сеть или протокол',
  8000070: 'Адрес контракта или Тикер',
  8000071: 'Имя экземпляра',
  8000072: 'Время создания инстанса',
  8000073: 'Статус инстанса',
  8000074: 'Сумма комиссии (всего)/U',
  8000075: 'Сумма комиссии (за последнюю неделю)/U',
  8000076: 'Сумма сделки (за последнюю неделю)/U',
  8000077: 'Количество сделок (за последнюю неделю)',
  8000078: 'Создать торговую пару',
  8000079: 'Продление',
  8000080: 'Листинг завершен',
  8000081: 'Будет исключен из листинга',
  8000082: 'Делистинг завершен',
  8000083: 'Выберите токен',
  8000084: 'Уведомление о внесении в список',
  8000085: 'Создание успешно',
  8000086: 'Листинг на свободном рынке',
  8000087: 'На SuperEx вы можете легко и бесплатно разместить свой список на бирже и иметь возможность получить до 80% дивидендов от торговых сборов.',
  8000088: 'Как это работает?',
  8000089: 'Создайте новую торговую пару',
  8000090: 'Я собираюсь листинговать монету.',
  8000091: 'Создание экземпляра торговой пары',
  8000092: 'Биржа SuperEx',
  8000093: 'Почему стоит выбрать нас?',
  8000094: 'Разнообразные возможности',
  8000095: 'Поддерживаются несколько цепочек и протоколов, включая BSC, ETH и SOL.',
  8000096: 'Немедленный листинг без ручной проверки, подобно децентрализованному процессу, и наслаждайтесь удобством торговли по книге заявок.',
  8000097: 'Поддерживается API',
  8000098: 'Вы можете использовать API интерфейс для проведения маркетмейкинга или торговли, что делает ваши операции более эффективными и автоматизированными.',
  8000099: 'Получите известность и трафик',
  8000100: 'Разместив листинг в Free Market, воспользуйтесь огромным пользовательским трафиком SuperEx и привлеките больше внимания.',
  8000101: 'Независимо от того, новичок вы или опытный трейдер, наш Free Market принесет вам новые впечатления и инвестиционные возможности. Создавайте свои собственные торговые пары, продвигайте любимые монеты и наслаждайтесь доходом от комиссионных за торговые операции!',
  8000102: 'Ваши общие активы должны превышать {resultData} USDT, прежде чем вы получите право создать торговую пару.',
  8000103: 'Листинг вашего любимого токена',
  8000104: 'Вы можете выбрать предпочитаемую валюту и создать торговую пару с USDT, чтобы создать уникальный торговый инструмент.',
  8000105: 'Получите комиссионные дивиденды.',
  8000106: 'Когда объем торгов созданного вами экземпляра торговой пары достигнет определенного порога, часть комиссионных за транзакции будет возвращена вам в качестве комиссии. Это позволяет вам, как создателю экземпляра торговой пары, также участвовать в прибыли от торговли.',
  8000107: 'Сейчас вы являетесь ограниченным пользователем и временно не можете создавать новые торговые пары. Пожалуйста, повторите попытку завтра.',
  8000108: 'Пожалуйста, выберите язык',
  8000109: 'Белая книга',
  8000110: 'Токен был запрещен к размещению!',
  8000111: 'Этот токен уже зарегистрирован в SuperEx Main Market, и вы не можете создать другую торговую пару!',
  8000112: 'Пожалуйста, введите действительный адрес контракта / тикер!',
  8000113: 'Ваш баланс ET на основной доске Spot недостаточен. Для создания нового экземпляра торговой пары необходимо оплатить управляющую плату в размере {num} ET. Пожалуйста, пополните счет и попробуйте снова.',
  8000114: 'Вы сделали слишком много неправильных вводов в процессе создания новой торговой пары сегодня. Поэтому сегодня вы больше не сможете подать ни одной заявки. Пожалуйста, повторите попытку завтра.',
  8000115: 'Токен уже существует, поэтому сейчас мы создадим для вас новый экземпляр торговой пары!',
  8000116: 'Пожалуйста, подтвердите следующую информацию:',
  8000117: 'Десятичная длина количества токенов',
  8000118: 'Как свободно листинговать монету',
  8000119: 'Полное имя токена',
  8000120: 'Десятичная длина цены токена',
  8000121: 'Листинг монет на SUPEREX: <em class="normal" style="color: #0CAA6D;">0 сборов за листинг! </em><em class="normal" style="color: #1D90F5;">0 затрат на коммуникацию! </em> Завершите листинг на бирже за 1 минуту и наслаждайтесь прибылью до <em class="normal" style="color: #F65D62;">80%</em>',
  8000122: 'Представление токена на английском языке',
  8000123: 'Необходимо указать следующую информацию:',
  8000124: 'Введенное вами имя экземпляра уже существует. Пожалуйста, введите другое.',
  8000125: 'Ниже приведена необязательная информация:',
  8000126: 'Пожалуйста, выберите основную цепочку или протокол, а также соответствующую плату за управление.',
  8000127: 'Шаг 1: Скопируйте и вставьте адрес контракта новой монеты.',
  8000128: 'Пожалуйста, введите адрес контракта / тикер.',
  8000129: 'Подтвердите',
  8000130: 'Ваш экземпляр торговой пары {currency} успешно создан!',
  8000131: 'Шаг 2: Если эта монета впервые появляется на нашей бирже, вам нужно заполнить несколько основных данных, таких как введение в монету и загрузка логотипа.',
  8000132: 'Рынки протокола BTC',
  8000133: 'Шаг 3: Вам нужно только назвать экземпляр этой торговой пары, которую вы создали. Затем процесс листинга завершается, и монету можно будет торговать публично.',
  8000134: 'Разместить токены',
  8000135: 'Введите общее предложение.',
  8000136: 'Шаг 4: Как только еженедельный объем торгов вашего экземпляра достигнет порогового значения, вы получите часть торговых сборов с этого экземпляра.',
  8000137: 'Если вы выберете 8, это означает, что значение цены вашего криптовалюты отображается с точностью до 0.00000001. Например, цена BTC отображается как $72186.12345678. Для большинства мем-монет мы рекомендуем выбрать 11.',
  8000138: 'Пожалуйста, введите',
  8000139: 'Я собираюсь начать листинг монеты',
  8000140: 'Пожалуйста, введите краткое описание токена на английском языке.',
  8000141: 'Инстанс можно просто понять как разные версии одной и той же торговой пары, одна из которых — это инстанс, созданный вами. Другие пользователи различают эти версии по именам инстансов. Если пользователи выберут ваш инстанс для торговли, у вас будет возможность получить соответствующую комиссию за транзакции.',
  8000142: 'Формат электронной почты некорректен.',
  8000143: 'Введите адрес запроса блокчейна.',
  8000144: 'Оборотное предложение',
  8000145: 'Оборотное предложение ограничено 1-20 цифрами в виде целого положительного числа.',
  8000146: 'Значок токена',
  8000147: 'Поддерживается формат PNG или JPG, размер файла - не более 5 МБ, загрузка возможна не более 10 раз в день.',
  8000148: 'Дата выпуска',
  8000149: 'Пожалуйста, выберите дату выпуска.',
  8000150: 'Пожалуйста, укажите ссылку на белую книгу.',
  8000151: 'Официальный сайт',
  8000152: 'Укажите ссылку на официальный сайт.',
  8000153: 'Листинг свободного рынка',
  8000154: 'Получение листинга вашего токена на бирже',
  8000155: 'Ограничение на ввод названия токена — 9 символов, поддерживаются только цифры, английские буквы и английские символы',
  8000156: 'Ограничение на ввод полного названия токена — 50 символов, поддерживаются только цифры, пробелы, английские буквы и английские символы',
  8000157: 'Общее предложение должно быть целым положительным числом от 1 до 20 цифр.',
  8000158: 'Начальный или конечный символ не может быть пробелом, и не может быть нескольких подряд идущих пробелов. Символ "/" и эмодзи не поддерживаются.',
  8000159: '1. Издатель несет ответственность за достоверность информации, а платформа оставляет за собой право в любое время исключить токены или экземпляр торговой пары из списка и в любое время скорректировать содержание информации.',
  8000160: '2. Издатель обязан провести тщательное исследование перечисленных токенов и нести ответственность за их обоснованность, соответствие и законность. Если платформа обнаружит в смарт-контракте токена какое-либо вредоносное, опасное или иное специфическое поведение или содержание, она напрямую исключит токен из списка и будет представлять интересы пользователей при предъявлении претензий к эмитенту.',
  8000161: '3. Если в дальнейшем эмитент или кто-либо другой захочет внести коррективы в информацию о токене, им необходимо обратиться в службу поддержки.',
  8000162: '4. Чтобы защитить интересы пользователей и исключить некачественные токены, если экземпляр торговой пары, созданный эмитентом, не соответствует требованиям нашей платформы к торговой активности, издатель будет уведомлен о делистинге примерно через неделю. Каждый понедельник платформа будет отправлять эмитентам уведомления о делистинге по электронной почте и через App Notifiications для экземпляров, не соответствующих требованиям. В течение 5 дней у издателей будет возможность подать заявку на продление листинга. Если заявка будет удовлетворена, будет предоставлено еще 4 недели времени наблюдения; в противном случае экземпляры будут исключены из списка.',
  8000163: '5. Если копия торговой пары, созданная эмитентом токенов, соответствует порогу дивидендов платформы по объему торгов, они получат соответствующие дивиденды от комиссий.',
  8000164: 'Вы готовы предоставить определенное количество токенов для операционных мероприятий и маркетинга, чтобы расширить влияние монеты?',
  8000165: '6. Издатель может связаться с нашей службой поддержки, чтобы подать заявку на участие в программе Market Maker.',
  8000166: 'Создать',
  8000167: 'Вы собираетесь создать экземпляр торговой пары {currency} и вычесть {upFee} ET из вашего счета на спотовом основном счете.',
  8000168: 'Нет',
  8000169: 'Да',
  8000170: 'Пожалуйста, введите ваш адрес электронной почты, чтобы наша команда по маркетингу могла связаться с вами',
  8000171: 'У вас есть рекомендатель или контактное лицо?',
  8000172: 'Пожалуйста, введите имя рекомендателя или контактную информацию.',
  8000173: 'Нажимая на этот флажок, вы признаете все связанные риски и соглашаетесь с нашими <a id="service_href" class="pointer" style="color: #D9A31A;text-decoration: underline" target="_self">Условиями и Положениями</a>.',
  8000174: 'Прибыль от листинга',
  8000175: 'Право на листинг на бирже',
  8000176: 'Этот токен сейчас не поддерживается для листинга!',
  8000177: 'Заполните информацию',
  8000178: 'Иди поделись',
  8000179: 'листинг на бирже!',
  8000180: 'SuperEx Free Market, криптовалютный мир пользователей, от пользователей, для пользователей!',
  8000181: 'Я создал торговую пару {symbol} на SuperEx! На Луну!',
  8000182: 'Сумма дивидендов за каждую транзакцию обновляется по понедельникам, но в процессе фактического распределения возможно задержка до 3 рабочих дней. Вы можете проверить соответствующие записи в разделе "История кошелька" - "Прочее" - "Основной рынок" через тип "Отправить награды".',
  8000183: 'Твиттер-аккаунт',
  8000184: 'Аккаунт Telegram',
  8000185: 'Аккаунт Discord',
  8000186: 'Введите действительную ссылку на Twitter!',
  8000187: 'Введите действительную ссылку на Telegram!',
  8000188: 'Введите действительную ссылку на Discord!',
  8000189: 'Введите ссылку Twitter',
  8000190: 'Введите ссылку Telegram',
  8000191: 'Введите ссылку Discord',
  8000192: 'Извините, содержание или связанные настройки разрешений смарт-контракта для этой валюты имеют высокие риски безопасности. Пожалуйста, попробуйте использовать другую валюту.',
  8000193: 'Извините, содержание смарт-контракта для этой валюты может содержать потенциальные риски. В данный момент ее нельзя добавить в список. Пожалуйста, попробуйте использовать другую валюту.',
  8000194: 'Примечание:',
  8000195: 'Вам нужно завершить пополнение для этого токена, прежде чем вы сможете разместить ордер на продажу.',
  8000196: 'Вам нужно перевести USDT на счет Free Market перед тем, как вы сможете разместить ордер на покупку.',
  8000197: 'Вам нужно подключить API, прежде чем вы сможете заниматься рыночным маркетингом.',
  8000198: 'Служба поддержки',
  8000199: 'Введите целое число от 5 до 12',

  8100013: 'Официальный канал проверки',
  8100014: 'Пожалуйста, введите проверочную информацию',
  8100015: 'Вы можете проверить следующую информацию',
  8100016: 'Разрешены только официальные электронные письма от SUPEREX.COM',
  8100017: 'Подтверждение личности официального BD',
  8100018: 'Пример: Официальная учетная запись Telegram/X(Twitter)',
  8100019: 'Проверка канала для листинга',
  8100020: 'Если вам нужно подписать контракт или произвести оплату, пожалуйста, подтвердите это у официального BD',
  8100021: 'Спасибо за интерес к <a href="/" style="color: #FFC72B" class="under-line pointer">SUPEREX.COM</a>, мы сделаем все возможное, чтобы защитить права и интересы каждого.',
  8100022: 'Неофициальный канал SuperEx',
  8100023: 'Официальный канал SuperEx',
  8100024: 'Введенное вами значение <em class="normal activeColor">{keyWord}</em> не является официальным каналом SuperEx. Пожалуйста, обеспечьте безопасность своих активов и защитите свою личную информацию.',
  8100025: 'Адрес <em class="normal activeColor">{keyWord}</em> в вашем запросе является {note}.',
  8100026: 'Советы по безопасности',
  8100027: '· Не взаимодействуйте с непроверенными аккаунтами.',
  8100028: '· Никому не сообщайте свои мнемонические фразы, зарегистрированную на SuperEx электронную почту, номер телефона и/или пароль.',
  8100029: '· Если вам нужна дополнительная помощь, пожалуйста, свяжитесь со службой поддержки по адресу support@superex.com.',
}
export default ru



// WEBPACK FOOTER //
// ./src/i18n/langs/languageGaea/ru.js